import type { SVGProps } from 'react'

const ARTICLE_UI_ICON_SPRITE = '/assets/article-ui-icons.svg'

export type ArticleUiIconId =
  | 'arrow-right'
  | 'check'
  | 'check-14'
  | 'check-circle'
  | 'chevron-down'
  | 'external-link'
  | 'flask'
  | 'info'
  | 'score-logo'
  | 'volume'
  | 'x'
  | 'x-14'

interface ArticleUiIconProps extends SVGProps<SVGSVGElement> {
  id: ArticleUiIconId
}

export const ArticleUiIcon = ({ id, children, ...props }: ArticleUiIconProps) => (
  <svg aria-hidden="true" focusable="false" {...props}>
    <use href={`${ARTICLE_UI_ICON_SPRITE}#${id}`} />
    {children}
  </svg>
)
